import React, { memo } from 'react'
import { Document, Font } from '@react-pdf/renderer'
import ItineraryReportCoverPdf from './ItineraryReportCoverPdf.component'
import ItineraryReportStatsPdf from './ItineraryReportStatsPdf.component'
import ItineraryReportCompanyPdf from './ItineraryReportCompanyPdf.component'
import { ItineraryReportPdfProps, CompanyFeature } from './ItineraryReportPdf.types'

// Registrar fontes
Font.register({
  family: 'Lato-700',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVew-FGC_p9dw.ttf',
    },
  ],
})

Font.register({
  family: 'Lato-900',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50Xew-FGC_p9dw.ttf',
    },
  ],
})

function ItineraryReportPdf({
  itinerary,
  space,
  attendant,
  generatedAt = new Date(),
}: ItineraryReportPdfProps) {
  const companies = itinerary.features
    .filter((f: CompanyFeature) => f.properties?.kind === 'interestPoint')
    .sort(
      (a: CompanyFeature, b: CompanyFeature) =>
        Number(a.properties.position) - Number(b.properties.position),
    )

  return (
    <Document>
      {/* Primeira página */}
      <ItineraryReportCoverPdf
        attendant={attendant}
        itinerary={itinerary}
        space={space}
        generatedAt={generatedAt}
      />

      {/* Estatísticas do relatório */}
      <ItineraryReportStatsPdf itinerary={itinerary} space={space} generatedAt={generatedAt} />

      {/* Lista de empresas */}
      {companies.map((company: CompanyFeature, index: number) => (
        <ItineraryReportCompanyPdf
          key={index}
          company={company}
          totalCompanies={companies.length}
          generatedAt={generatedAt}
        />
      ))}
    </Document>
  )
}

export default memo(ItineraryReportPdf)
